<div class="background">
  <div class="desktop-background">
    <div class="header" data-cy="deposits-main-header">
      {{ 'money.depositHeader' | translate }}
    </div>
    <div class="description" data-cy="deposits-header-description">
      {{ 'money.depositDescription' | translate }}
    </div>
  </div>

  @if (!preloader) {
    <div class="investments-container">
      <div class="investments-layout" data-cy="deposit-available-investments-container">
        @if (userInvestments.length === 0) {
          <p class="no-data-container" data-cy="no-available-investments">
            {{ 'toastNotifications.messages.noAvailableInvestments' | translate }}
          </p>
        } @else {
          @for (investment of userInvestments; track investment.id) {
            <div class="investment">
              <libero-deposit-investment-button [investmentData]="investment" data-cy="deposit-investment-button"></libero-deposit-investment-button>
            </div>
          }
        }
      </div>
    </div>
  } @else {
    <libero-preload-spinner></libero-preload-spinner>
  }
</div>

<div class="phone-border">
  <div class="phone-corner"></div>
</div>

<div class="action-buttons" data-cy="deposits-action-buttons-container">
  @if (loggedUser.managementType === 'EXECUTION_ONLY') {
    <div class="label-tooltip-container">
      <div class="create-new-label">
        {{ 'global.createNewStrategy' | translate }}
      </div>
      <libero-tooltip-button [explainPerson]="'marketa_nemcova'">
        {{ 'global.tooltips.createNewStrategy' | translate }}
      </libero-tooltip-button>
    </div>
    <libero-button
      [routerLink]="'/strategy/pick'"
      label="{{ 'global.buttons.createStrategy' | translate }}"
      btnClasses="btn--primary btn--big"
      [disabledTooltipText]="disableInvestmentCreation ? 'liquidationDisabledStrategy' : null"
      [buttonDisabled]="disableInvestmentCreation"
    ></libero-button>
  }
  <div class="label-tooltip-container">
    <span class="create-new-label">
      {{ 'global.createNewPortfolio' | translate }}
    </span>
    <libero-tooltip-button [explainPerson]="'marketa_nemcova'">
      {{ 'global.tooltips.createNewPortfolio' | translate }}
    </libero-tooltip-button>
  </div>
  <libero-button
    [routerLink]="'/portfolio/new'"
    label="{{ 'global.buttons.createPortfolio' | translate }}"
    btnClasses="btn--primary btn--big"
    [disabledTooltipText]="disableInvestmentCreation ? 'liquidationDisabledPortfolio' : null"
    data-cy="money-new-portfolio-button"
    [buttonDisabled]="disableInvestmentCreation"
  ></libero-button>
</div>
